module.exports = require("lodash/reduce");


//////////////////
// WEBPACK FOOTER
// external "lodash/reduce"
// module id = 70
// module chunks = 0